// src/components/Dashboard.jsx
import React, { useEffect } from "react";
import { BASE_URL } from "../utils";
import { useMode } from "../contexts/ModeContext";
import { useNavigate } from "react-router-dom";
import ModuleDashboard from "./ModuleDashboard";

/**
 * Dashboard - now only renders WebSurrogate Dashboard.
 * If app is in 'legacy' mode, redirect user to /legacy/dashboard.
 */

export default function Dashboard() {
  const { mode } = useMode();
  const navigate = useNavigate();

  useEffect(() => {
    if (mode === "legacy") {
      navigate("/legacy/dashboard", { replace: true });
      return;
    }
    if (mode === "violation") {
      navigate("/violations/dashboard", { replace: true });
    }
  }, [mode, navigate]);

  return (
    <ModuleDashboard
      moduleKey="WS"
      eyebrow="Web Platform"
      title="Web Surrogate Dashboard"
      subtitle="Overview of Approved, Rejected, and Processing cases"
      sectionTitle="Web Surrogates"
      sectionSubtitle="Live data from the Web Surrogates system"
      fetchUrl={`${BASE_URL}/api/case/status-labels`}
      totalLabel="cases"
      showWorkingBadge={false}
    />
  );
}
